import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Button } from 'react-bootstrap';
import { Person } from 'react-bootstrap-icons';
// eslint-disable-next-line
import logo from '!file-loader!src/logo.svg';
import AuthContext from '../../contexts/auth-context';

const NavLink = ({ children, to }) => (
  <Nav>
    <Link to={to} className="nav-link px-2 mx-2 py-md-0 py-2">
      {children}
    </Link>
  </Nav>
);

const Header = () => {
  const auth = useContext(AuthContext);
  const { isLoggedIn, isAdmin } = auth;
  return (
    <Navbar bg="light" variant="light" expand="md" className="px-2 px-md-4">
      <Link to={'/'} className="text-decoration-none">
        <Navbar.Brand className="me-0 me-md-3">
          <img alt="" src={logo} height="30px" className="p-1" style={{ maxWidth: '20vw' }} />
          <span style={{ fontSize: '1rem' }}>Utah County Tip Hotline</span>
        </Navbar.Brand>
      </Link>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <NavLink to={'/'}>Submit a Tip</NavLink>
        {/* {isAdmin && <NavLink to={'/users'}>Users</NavLink>} */}
        {isAdmin && <NavLink to={'/submissions'}>Submissions</NavLink>}
        {isAdmin && <NavLink to={'/users'}>Users</NavLink>}
        <span className="flex-grow-1" />
        {isLoggedIn && (
          <Button
            variant="outline-dark"
            className="d-none d-md-flex align-items-center"
            onClick={auth.logout}
            data-cy="logout"
          >
            <Person className="me-1" />
            Log Out
          </Button>
        )}
        {!isLoggedIn && (
          <form action={`${process.env.PUBLIC_URL}/login`}>
            <Button as="input" type="submit" value="Log In" variant="outline-dark" />
          </form>
        )}
        <Nav className="d-md-none d-block" onClick={auth.logout}>
          <span className="nav-link px-2 mx-2 py-md-0 py-2">Log Out</span>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
